export const config = {
  baseURL: "https://www.chunki.app/",
};
